import { NgbDateParserFormatter, NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {Injectable} from "@angular/core";
import {format, isValid, parse} from "date-fns";

interface ParseOutput {
  parsedDate: Date;
  delimiter: string;
}

@Injectable()
export class CustomNgbDateParserFormatter extends NgbDateParserFormatter {
  private _currentDelimiter = '/';

  private static parseDate(dateString: string): ParseOutput | null {
    let parsedDate: Date | null;
    for (const delimiter of ['/', '-']) {
      parsedDate = parse(dateString, `MM${delimiter}dd${delimiter}yyyy`, new Date());
      if (isValid(parsedDate)) {
        return {parsedDate, delimiter};
      }
    }
    return null;
  }

  static dateFromNgbDateStruct(ngbDateStruct: NgbDateStruct): Date | null {
    if (!ngbDateStruct) {
      return null;
    }
    if (typeof ngbDateStruct === "string") {
      return null;
    }
    return new Date(ngbDateStruct.year, ngbDateStruct.month -1, ngbDateStruct.day);
  }

  constructor() {
    super();
  }

  format(ngbDate: NgbDateStruct | null): string {
    if (ngbDate === null) {
      return '';
    }
    const date = CustomNgbDateParserFormatter.dateFromNgbDateStruct(ngbDate);
    return format(date, `MM${this._currentDelimiter}dd${this._currentDelimiter}yyyy`);
  }

  parse(value: string): NgbDateStruct | null {
    const parseOutput = CustomNgbDateParserFormatter.parseDate(value);
    if (!parseOutput) {
      return null;
    }
    this._currentDelimiter = parseOutput.delimiter;
    return {
      month: parseOutput.parsedDate.getMonth() +1,
      day: parseOutput.parsedDate.getDate(),
      year: parseOutput.parsedDate.getFullYear()
    };
  }
}
